import { useEffect, useState } from 'react';
import axios from 'axios';
import { ENDPOINTS } from '../../../Utils/Endpoints';
import { Models } from '../../../Utils/ModelsCarBooking';

const EMPTY = {
    idReserva: 0,
    tipo: '',
    combustible: '',
    kmOdometro: '',
    observaciones: '',
    fechaRegistro: '',
    activo: true,
};

export default function Modal({
    open,
    mode = 'new',
    data = null,
    onClose,
    onSubmit,
    inline = false,
}) {
    const [form, setForm] = useState(EMPTY);
    const [errors, setErrors] = useState({
        idReserva: '',
        tipo: '',
        combustible: '',
        kmOdometro: '',
        observaciones: '',
        fechaRegistro: '',
    });

    const validateField = (field, rawValue) => {
        const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
        let error = '';

        switch (field) {
            case 'idReserva':
                if (!value || Number(value) <= 0) error = 'El ID de reserva es obligatorio.';
                break;
            case 'tipo':
                if (!value) error = 'El tipo es obligatorio.';
                break;
            case 'combustible':
                if (value === '' || value === null || value === undefined) error = 'El combustible es obligatorio.';
                break;
            case 'kmOdometro':
                if (value === '' || value === null || value === undefined) error = 'El kilometraje es obligatorio.';
                break;
            case 'observaciones':
                // Opcional? Si es obligatorio: if (!value) error = 'Las observaciones son obligatorias.';
                break;
            case 'fechaRegistro':
                if (!value) error = 'La fecha de registro es obligatoria.';
                break;
            default:
                break;
        }

        setErrors((prev) => ({ ...prev, [field]: error }));
        return !error;
    };

    const validateAll = () => {
        const fields = ['idReserva', 'tipo', 'combustible', 'kmOdometro', 'fechaRegistro'];
        let isValid = true;
        fields.forEach(f => {
            if (!validateField(f, form[f])) isValid = false;
        });
        return isValid;
    };

    const handleChange = (field, value) => {
        setForm((prev) => ({ ...prev, [field]: value }));
        validateField(field, value);
    };

    useEffect(() => {
        if (mode === 'edit' && data) {
            const filled = {
                idChecklist: data.idChecklist ?? 0,
                idReserva: data.idReserva ?? 0,
                tipo: data.tipo ?? '',
                combustible: data.combustible ?? '',
                kmOdometro: data.kmOdometro ?? '',
                observaciones: data.observaciones ?? '',
                fechaRegistro: (data.fechaRegistro ?? '').slice(0, 10),
                activo: data.activo ?? true,
            };
            setForm(filled);
            validateField('idReserva', filled.idReserva);
            validateField('tipo', filled.tipo);
            validateField('combustible', filled.combustible);
            validateField('kmOdometro', filled.kmOdometro);
            validateField('fechaRegistro', filled.fechaRegistro);
        } else {
            setForm({ ...EMPTY, fechaRegistro: new Date().toISOString().slice(0, 10) });
            setErrors({ idReserva: '', tipo: '', combustible: '', kmOdometro: '', observaciones: '', fechaRegistro: '' });
        }
    }, [mode, data]);

    if (!open) return null;

    const hasErrors = Object.values(errors).some((e) => !!e);
    const isSaveDisabled =
        !form.idReserva ||
        !form.tipo ||
        form.combustible === '' ||
        form.kmOdometro === '' ||
        !form.fechaRegistro ||
        hasErrors;

    const errorStyle = {
        color: '#b91c1c',
        fontSize: '.8rem',
        display: 'block',
        marginTop: '4px',
    };

    const Header = (
        <div
            className="roles-topbar"
            style={{
                marginBottom: '0.6rem',
                paddingRight: 16,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                flex: '0 0 auto',
            }}>
            <h3 className="roles-title" style={{ marginRight: 0 }}>
                {mode === 'new' ? 'Nuevo Checklist de Viaje' : 'Editar Checklist de Viaje'}
            </h3>
            <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
        </div>
    );

    const Body = (
        <div
            style={{
                paddingLeft: '12%',
                paddingRight: 16,
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '0.8rem',
                overflowY: 'auto',
                flex: '1 1 auto',
                minHeight: 0,
            }}>

            {/* Id Reserva */}
            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Id Reserva:</label>
                <br /><br />
                <input
                    className={`infoField${errors.idReserva ? ' infoField--error' : ''}`}
                    type="number"
                    min={1}
                    value={form.idReserva}
                    onChange={(e) => handleChange('idReserva', Number(e.target.value) || 0)}
                />
                {errors.idReserva && <small style={errorStyle}>{errors.idReserva}</small>}
            </div>

            {/* Tipo */}
            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Tipo:</label>
                <br /><br />
                <select
                    className={`infoField${errors.tipo ? ' infoField--error' : ''}`}
                    value={form.tipo}
                    onChange={(e) => handleChange('tipo', e.target.value)}
                >
                    <option value="">-- Selecciona --</option>
                    <option value="Entrega">Entrega</option>
                    <option value="Devolucion">Devolución</option>
                </select>
                {errors.tipo && <small style={errorStyle}>{errors.tipo}</small>}
            </div>

            {/* Combustible */}
            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Combustible (Lts):</label>
                <br /><br />
                <input
                    className={`infoField${errors.combustible ? ' infoField--error' : ''}`}
                    type="number"
                    min={0}
                    value={form.combustible}
                    onChange={(e) => handleChange('combustible', e.target.value)}
                />
                {errors.combustible && <small style={errorStyle}>{errors.combustible}</small>}
            </div>

            {/* KM Odómetro */}
            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>KM Odómetro:</label>
                <br /><br />
                <input
                    className={`infoField${errors.kmOdometro ? ' infoField--error' : ''}`}
                    type="number"
                    step="any"
                    value={form.kmOdometro}
                    onChange={(e) => handleChange('kmOdometro', e.target.value)}
                />
                {errors.kmOdometro && <small style={errorStyle}>{errors.kmOdometro}</small>}
            </div>

            {/* Fecha Registro */}
            <div>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Fecha Registro:</label>
                <br /><br />
                <input
                    className={`infoField${errors.fechaRegistro ? ' infoField--error' : ''}`}
                    type="date"
                    value={form.fechaRegistro}
                    onChange={(e) => handleChange('fechaRegistro', e.target.value)}
                />
                {errors.fechaRegistro && <small style={errorStyle}>{errors.fechaRegistro}</small>}
            </div>

            {/* Observaciones */}
            <div style={{ gridColumn: '1 / 3' }}>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Observaciones:</label>
                <br /><br />
                <textarea
                    className={`infoField${errors.observaciones ? ' infoField--error' : ''}`}
                    value={form.observaciones}
                    onChange={(e) => handleChange('observaciones', e.target.value)}
                    rows={3}
                    maxLength={500}
                />
                {errors.observaciones && <small style={errorStyle}>{errors.observaciones}</small>}
            </div>
        </div>
    );

    const Footer = (
        <div
            style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '.6rem',
                marginTop: '.8rem',
                paddingRight: 16,
                flex: '0 0 auto',
            }}
        >
            <button className="roles-btn" onClick={onClose}>Cancelar</button>
            <button
                className="btn-action"
                onClick={() => {
                    if (validateAll()) onSubmit(form, mode);
                }}
                disabled={isSaveDisabled}
                style={{
                    opacity: isSaveDisabled ? 0.5 : 1,
                    cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
                }}
            >
                {mode === 'new' ? 'Guardar' : 'Actualizar'}
            </button>
        </div>
    );

    if (inline) {
        return (
            <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                {Header}
                {Body}
                {Footer}
            </div>
        );
    }

    return (
        <div
            className="roles-confirm-overlay"
            role="dialog"
            aria-modal="true"
            style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(15,23,42,.45)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 16,
                zIndex: 1000,
            }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
        >
            <div
                className="roles-confirm-card"
                style={{
                    width: 'min(900px, 96vw)',
                    maxHeight: '85vh',
                    background: '#fff',
                    borderRadius: 12,
                    boxShadow: '0 10px 30px rgba(0,0,0,.25)',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                }}
            >
                {Header}
                {Body}
                {Footer}
            </div>
        </div>
    );
}
